const { roleWithIds, allowedRoles } = require("./rolesList");

export const getRolesIDAgainstAllowedRoles = (allowedRoles = {}) => {
    let roleIds = [];
    Object.keys(allowedRoles).forEach(role => {
        if (allowedRoles[role]) {
            roleIds.push(roleWithIds[role]);
        }
    });
    return roleIds;
}

export const isHasAccess = (allowedRoles = {}, userRole = null) => {
    const roles = getRolesIDAgainstAllowedRoles(allowedRoles);
    if (roles.includes(parseInt(userRole))) return true;
    return false;
}

export const allowAllRoles = () => {
    const obj = { ...allowedRoles };
    for (const role in obj) {
        obj[role] = true;
    }
    return obj;
}

export const allowSystemAdmin = () => {
    const obj = { ...allowedRoles };
    return {
        ...obj,
        dataMigrator: true,
        superAdministrator: true,
    };
}

export const allowWOAHAdmin = () => {
    const obj = { ...allowedRoles };
    return {
        ...obj,
        businessAdmin: true,
        itAdmin: true,
        cbdStaff: true
    };
}

export const allowPnD = () => {
    const obj = { ...allowedRoles };
    return {
        ...obj,
        pnDG: true,
        pnDR: true
    };
}

export const allowDelegates = () => {
    const obj = { ...allowedRoles };
    return {
        ...obj,
        delegates: true,
        focalPoints: true,
        otherNationalOfficials: true
    };
}

export const allowExperts = () => {
    const obj = { ...allowedRoles };
    return {
        ...obj,
        experts: true
    };
}